import { render } from "./unset.vue?vue&type=template&id=f995bf8a&ts=true"
import script from "./unset.vue?vue&type=script&lang=ts"
export * from "./unset.vue?vue&type=script&lang=ts"

import exportComponent from "/home/asan/haisha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__